import React from 'react'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI.js'
import TabLinkUI from '../../../widgets/output/TabLinkUI'
import PageTitleUI from '../../../widgets/output/PageTitleUI'
import CacheDeleteSF from '../../../components/superUser/developer/CacheDeleteSF'
import RaiseExceptionSF from '../../../components/superUser/developer/RaiseExceptionSF'
import DDbTablesCreateSF from '../../../components/superUser/developer/DDbTablesCreateSF'
import DDbMessagesCreateSF from '../../../components/superUser/developer/DDbMessagesCreateSF'
import DDbChartOfAccountCreateSF from '../../../components/superUser/developer/DDbChartOfAccountCreateSF'

const DBConfigPageUI = ({context,
  }) =>
  <SuperUserSettingsPageUI context={context} className='pg_su' topnav='settings'
    headerText='Developer' page='developer'
  >
    <TabLinkUI label='Test Data' to='/su/testdata' />
    <TabLinkUI label='DB Configurations' to='/su/config' active={true} />
    <div className='g_m_top_100' />

    <DDbTablesCreateSF context={context} />
    <div className='g_m_top_100' />
    <DDbMessagesCreateSF context={context} />
    <div className='g_m_top_100' />
    <DDbChartOfAccountCreateSF context={context} />
    <div className='g_m_top_100' />
    <CacheDeleteSF context={context} />
    <div className='g_m_top_100' />
    <RaiseExceptionSF context={context} />
    <div className='g_m_top_100' />
  </SuperUserSettingsPageUI>

export default DBConfigPageUI
